import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { spanish } from '../../config/config';
import apiMarkdown from '../../api/Markdown';
import Markdown from '../../components/Markdown';

const TermsConditions = () => {
  const [content, setContent] = useState(null);
  useEffect(async () => {
    setContent(await apiMarkdown.getTerms());
  }, []);
  const output = (
    <>
      <Helmet
        title={spanish ? 'Términos y condiciones' : 'Terms and Conditions'}
      />
      <Markdown data={content} />
    </>
  );
  return output;
};

export default TermsConditions;
